<template>
  <div>
    <v-card style="padding-bottom: 200px" flat class="mx-auto">
      <div class="panel-header">
        <v-btn x-large icon class="ml-2" @click="$router.push('/')">
          <v-icon color="white">mdi-chevron-left</v-icon>
        </v-btn>
        <div class="header-title">Mitarbeiter Panel</div>
        <v-spacer></v-spacer>

        <div v-if="!isSelfSelectedEmployee && isTrainerMode && getSelectedEmployee" class="employee-chip" @click="$router.push('/select-employee')">
          <v-avatar size="32" class="mr-2">
            <img :src="employeePicture" alt="Mitarbeiter" />
          </v-avatar>
          <span>{{ getSelectedEmployee.fullName }}</span>
          <v-icon color="white" right small>mdi-chevron-down</v-icon>
        </div>

        <v-btn fab small class="mr-2" @click="$router.push('/dashboard')" color="primary">
          <v-icon>mdi-view-dashboard</v-icon>
        </v-btn>
      </div>
      <div v-if="isTrainerMode">
        <customer-dashboard
          v-if="selectedCustomer"
          :fetching-user-pool-data="fetchingUserPoolData"
          :customer="selectedCustomer"
          :entry-data="selectedEntryForDashboard"
          @clear-customer="clearSelectedCustomer"
          @reload-customer="fetchCustomerInfosAndUpdatePool(selectedCustomer)"
          @create-interaction="createInteraction"
          @create-anamnese="createAnamnese"
          @edit-anamnese="showMedicalHistory"
          @create-tp="createTP" />

        <div v-else class="pa-4 pt-8">
          <v-row justify="center" align="stretch">
            <v-col cols="12" sm="12" md="4">
              <v-card @click="showUserSearch = true" class="glass-action-card h-100" outlined>
                <v-icon size="48" class="mb-3 card-icon">mdi-account-search</v-icon>
                <div class="card-title">Kunde suchen</div>
                <div class="card-subtitle">Bestehenden Kunden auswählen</div>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-card @click="createAccount" class="glass-action-card h-100" outlined>
                <v-icon size="48" class="mb-3 card-icon">mdi-account-plus</v-icon>
                <div class="card-title">Neuer Kunde</div>
                <div class="card-subtitle">Einen neuen Account anlegen</div>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-card @click="$router.push('/panel/membercard')" class="glass-action-card h-100" outlined>
                <v-icon size="48" class="mb-3 card-icon">mdi-card-account-details-star-outline</v-icon>
                <div class="card-title">11-Tage Aktionen</div>
                <div class="card-subtitle">Membercard-Kampagnen verwalten</div>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-card @click="showTowelAdminDialog = true" class="glass-action-card h-100" outlined>
                <v-icon size="48" class="mb-3 card-icon" color="blue">mdi-towel</v-icon>
                <div class="card-title">Duschtuch-Aktion</div>
                <div class="card-subtitle">Reservierungen verwalten</div>
              </v-card>
            </v-col>
            <v-col v-show="false" cols="12" sm="6" md="4">
              <v-card style="position: relative" @click="showTdotDialog = true" class="glass-action-card h-100" outlined>
                <v-chip color="primary" text-color="white" small style="position: absolute; top: 8px; right: 8px"> 1+2 November </v-chip>
                <v-icon size="48" class="mb-3 card-icon" color="blue">mdi-towel</v-icon>
                <div class="card-title">Tag der offenen Tür</div>
                <div class="card-subtitle">Wettbewerbe</div>
              </v-card>
            </v-col>
            <v-col cols="12" v-if="false" sm="6" md="4">
              <v-card style="position: relative" @click="showHyroxDialog = true" class="glass-action-card h-100" outlined>
                <v-chip color="primary" text-color="white" small style="position: absolute; top: 8px; right: 8px"> 16. - 18. Januar </v-chip>
                <div class="card-title">Hyrox</div>
                <div class="card-subtitle">Auto Wettbewerb</div>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-card style="position: relative" @click="showPartyListDialog = true" class="glass-action-card h-100" outlined>
                <v-chip color="primary" text-color="white" small style="position: absolute; top: 8px; right: 8px"> 28.02.2026 </v-chip>
                <div class="card-title">Party</div>
                <div class="card-subtitle">well come FIT</div>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <div>
          <!-- 
                <checkin-pool-emp-panel @entry-selected="prepareAndShowDashboard" ref="checkinPoolEmpPanel" />
              -->
          <checkin-pool v-if="!selectedCustomer && !isLocal" ref="checkinPool" />
          <checkin-pool-new v-show="!selectedCustomer" @selectCustomerFromPool="customerSelectedFromPool" v-if="isLocal"></checkin-pool-new>
        </div>
      </div>

      <div v-else>
        <customer-dashboard
          v-if="selectedCustomer"
          :fetching-user-pool-data="fetchingUserPoolData"
          :customer="selectedCustomer"
          :entry-data="selectedEntryForDashboard"
          @clear-customer="clearSelectedCustomer"
          @reload-customer="fetchCustomerInfosAndUpdatePool(selectedCustomer)"
          @create-interaction="createInteraction"
          @create-anamnese="createAnamnese"
          @edit-anamnese="showMedicalHistory"
          @create-tp="createTP" />
        <v-row v-else no-gutters class="pt-3" align="center">
          <v-col class="px-5 mt-4" cols="12">
            <v-card class="options-card" outlined elevation="0">
              <v-card-title class="font-weight-bold text-subtitle-1 mb-0" style="color: #313131; letter-spacing: 0.2px">
                <v-icon class="pr-3" color="primary">mdi-layers-triple</v-icon>
                Shortcuts
              </v-card-title>
              <v-row no-gutters class="pa-3">
                <v-col cols="4" sm="3" class="px-1 pb-3 text-center d-flex flex-column align-center">
                  <v-btn height="50px" width="50px" class="elevation-1" @click="createInteraction()" fab color="white">
                    <v-icon color="primary">mdi-face-agent</v-icon>
                  </v-btn>
                  <span class="shortcut-label">Interaktion hinzufügen</span>
                </v-col>
                <v-col cols="4" sm="3" class="px-1 pb-3 text-center d-flex flex-column align-center">
                  <v-btn height="50px" width="50px" class="elevation-1" @click="createAnamnese()" fab color="white">
                    <v-icon color="primary">mdi-alpha-a-box</v-icon>
                  </v-btn>
                  <span class="shortcut-label">Anamnese erstellen</span>
                </v-col>
                <v-col cols="4" sm="3" class="px-1 pb-3 text-center d-flex flex-column align-center">
                  <v-btn height="50px" width="50px" class="elevation-1" @click="createAccount" fab color="white">
                    <v-icon color="primary">mdi-account-plus</v-icon>
                  </v-btn>
                  <span class="shortcut-label">Account erstellen</span>
                </v-col>
                <v-col cols="4" sm="3" class="px-1 pb-3 text-center d-flex flex-column align-center">
                  <v-btn height="50px" width="50px" class="elevation-1" @click="$router.push('/panel/membercard')" fab color="white">
                    <v-icon color="primary">mdi-card-account-details-star-outline</v-icon>
                  </v-btn>
                  <span class="shortcut-label">11-Tage Kampagnen</span>
                </v-col>
                <v-col v-if="userService.hasRight('c_create_customer')" cols="4" sm="3" class="px-1 pb-3 text-center d-flex flex-column align-center">
                  <v-btn height="50px" width="50px" class="elevation-1" @click="$router.push(`/workouts/createnew`)" fab color="white">
                    <v-icon color="primary">mdi-dumbbell</v-icon>
                  </v-btn>
                  <span class="shortcut-label">Split Plan erstellen</span>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <checkin-pool v-if="false" ref="checkinPool" />
        <checkin-pool-new v-show="isLocal && !selectedCustomer" @selectCustomerFromPool="customerSelectedFromPool"></checkin-pool-new>
      </div>

      <customerInteraction @interactionCreated="forceRefetchCheckins" ref="customerInteraction" />
      <anamnese-bogen-create @submitted="showGFRecommendations" ref="anamneseBogenRef"></anamnese-bogen-create>
      <nutrition-sale-form @submitted="showGFRecommendations" ref="nutritionSaleForm"></nutrition-sale-form>
      <register
        @register="newAccountRegistered()"
        :auto-login="false"
        :requirePassword="false"
        @close="showRegisterDialog = false"
        :active="showRegisterDialog"></register>
    </v-card>
    <router-view></router-view>

    <v-dialog v-model="showUserSearch" max-width="600px" persistent>
      <v-card class="glass-dialog-card">
        <v-card-title class="text-h5 font-weight-bold justify-center pb-6">
          <v-icon left large class="mr-3">mdi-account-search</v-icon>
          Kunde auswählen
        </v-card-title>
        <v-card-text class="px-5">
          <user-search ignoreRights label="Namen des Kunden eingeben..." :return-user="true" @update="customerSelected"></user-search>
        </v-card-text>
        <v-card-actions class="d-flex justify-center pt-4 pb-2">
          <v-btn outlined large rounded color="grey darken-2" @click="showUserSearch = false">
            <v-icon left>mdi-close</v-icon>
            Abbrechen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- NEUER DIALOG FÜR HANDTUCH-ADMIN -->
    <v-dialog v-model="showTowelAdminDialog" fullscreen persistent transition="dialog-bottom-transition">
      <towel-admin v-if="showTowelAdminDialog" @close="showTowelAdminDialog = false"></towel-admin>
    </v-dialog>
    <v-dialog v-model="showTdotDialog" fullscreen persistent transition="dialog-bottom-transition">
      <tdot-competition v-if="showTdotDialog" @close="showTdotDialog = false"></tdot-competition>
    </v-dialog>
    <v-dialog v-model="showHyroxDialog" fullscreen persistent transition="dialog-bottom-transition">
      <hyrox-competition v-if="showHyroxDialog" @close="showHyroxDialog = false"></hyrox-competition>
    </v-dialog>
    <v-dialog v-model="showPartyListDialog" fullscreen persistent transition="dialog-bottom-transition">
      <party-list v-if="showPartyListDialog" @close="showPartyListDialog = false"></party-list>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import api from "@/api"
import userService from "@/services/userService"
import checkinPool from "./components/checkinPool.vue"
import checkinPoolNew from "./components/checkinPoolNew.vue"
import checkinPoolEmpPanel from "./components/checkinPoolEmpPanel.vue"
import customerInteraction from "@/components/employee/customerInteraction.vue"
import nutritionSaleForm from "@/components/nutritionSaleForm"
import anamneseBogenCreate from "@/components/anamneseBogenCreate"
import register from "@/views/launchScreen/register.vue"
import CustomerDashboard from "./components/customerDashboard.vue"
import userSearch from "@/components/userSearch"
import TowelAdmin from "./components/TowelAdmin.vue" // NEUER IMPORT
import TdotCompetition from "@/components/marketing/TdotCompetition.vue" // NEUER IMPORT
import HyroxCompetition from "@/components/marketing/HyroxCompetition.vue" // NEUER IMPORT
import PartyList from "@/components/marketing/PartyList.vue" // NEUER IMPORT

export default {
  components: {
    checkinPool,
    checkinPoolEmpPanel,
    customerInteraction,
    anamneseBogenCreate,
    register,
    nutritionSaleForm,
    CustomerDashboard,
    userSearch,
    TowelAdmin,
    TdotCompetition,
    PartyList,
    checkinPoolNew,
  },
  data() {
    return {
      showRegisterDialog: false,
      showDialog: true,
      userService,
      showUserSearch: false,
      fetchingUserPoolData: false,
      showTowelAdminDialog: false, // NEUER STATE FÜR DIALOG
      showTdotDialog: false, // NEUER STATE FÜR DIALOG
      showHyroxDialog: false, // NEUER STATE FÜR DIALOG
      showPartyListDialog: false, // NEUER STATE FÜR DIALOG
    }
  },
  computed: {
    ...mapGetters("studioStore", ["getSelectedEmployee"]),
    ...mapGetters("panelStore", { selectedCustomer: "getSelectedCustomer" }),
    isLocal() {
      return true
      return window.location.hostname === "localhost" || window.location.hostname.includes("10.13.4.147")
    },
    isTrainerMode() {
      return !!this.getSelectedEmployee
    },
    isSelfSelectedEmployee() {
      return this.getSelectedEmployee && this.getSelectedEmployee.user === this.userService.getUserId()
    },
    showPanel() {
      return this.$route.name === "employeePanel"
    },
    employeePicture() {
      if (this.getSelectedEmployee && this.getSelectedEmployee.picture) {
        return "/img/profilbilder/" + this.getSelectedEmployee.picture
      }
      return "/img/icons/user_placeholder.png"
    },
  },
  created() {
    console.log("huhuuuh i has glade")
  },
  methods: {
    ...mapActions("panelStore", ["selectCustomer", "clearCustomer", "setCustomerInfos"]),
    showMedicalHistory(id, editMode = false) {
      this.$refs.anamneseBogenRef.setVisible(id, editMode)
    },
    async customerSelectedFromPool(entry) {
      if (!entry) return
      try {
        const fullUserData = await api.getUserById(entry.user._id)
        this.selectCustomer(fullUserData.user)
        this.setCustomerInfos(entry)
        this.showUserSearch = false
      } catch (error) {
        this.$toast.error("Kunde konnte nicht geladen werden.")
      }
    },
    async customerSelected(customer) {
      if (!customer) return
      try {
        const fullUserData = await api.getUserById(customer._id)
        this.selectCustomer(fullUserData.user)
        this.showUserSearch = false
      } catch (error) {
        this.$toast.error("Kunde konnte nicht geladen werden.")
      }
      this.fetchCustomerInfosAndUpdatePool(customer)
    },
    async fetchCustomerInfosAndUpdatePool(customer) {
      if (!customer) return
      this.fetchingUserPoolData = true
      try {
        const fullUserData = await api.fetchCustomerInfosAndUpdatePool({ roodyUserId: customer._id })
        this.setCustomerInfos(fullUserData)
      } catch (error) {
        console.log(error)
        this.$toast.error("Kunde konnte nicht geladen werden.")
      } finally {
        this.fetchingUserPoolData = false
      }
    },
    clearSelectedCustomer() {
      this.clearCustomer()
    },
    clearDashboard() {
      this.selectedEntryForDashboard = null
      // Optional: Checkin-Pool neu laden, falls sich was geändert hat
      if (this.$refs.checkinPool) {
        this.$refs.checkinPool.fetchCheckinPool(true)
      }
    },
    async prepareAndShowDashboard(entry) {
      this.isDashboardLoading = true
      this.selectedEntryForDashboard = {
        ...entry, // Basis-Checkin-Daten (user, interactions, checkinDate...)
        documents: [],
        courses: [],
        workouts: [], // Diese sind für die Anzeige "Letzte TP" etc.
        contract: {},
      }
      this.selectCustomer(entry.user)
      try {
        // Lade die zusätzlichen Daten, die nicht im Check-in-Objekt sind
        const [documents, stats, contractResult] = await Promise.all([
          api.getCustomerDocuments(entry.user._id).catch(() => null),
          api.fetchUserAttendanceStats(entry.user._id).catch(() => ({ courses: [], workouts: [] })),
          entry.tacId ? api.fetchCurrentTACMemberDetailsByTACId(entry.tacId).catch(() => null) : Promise.resolve(null),
        ])

        let contract = null
        if (contractResult && contractResult.Result.resultStatusFlag === "SUCCESS") {
          contract = contractResult.MemberDetail
        }

        // Erstelle das finale, vollständige Objekt für das Dashboard
        this.selectedEntryForDashboard = {
          ...entry, // Basis-Checkin-Daten (user, interactions, checkinDate...)
          documents: documents,
          courses: stats.courses || [],
          workouts: stats.workouts || [], // Diese sind für die Anzeige "Letzte TP" etc.
          contract: contract,
        }
      } catch (error) {
        console.error("Fehler beim Vorbereiten der Dashboard-Daten:", error)
        this.$toast.error("Kundendetails konnten nicht vollständig geladen werden.")
      } finally {
        this.isDashboardLoading = false
      }
    },
    forceRefetchCheckins() {
      if (this.$refs.checkinPool) {
        this.$refs.checkinPool.fetchCheckinPool(true)
      }
      if (this.$refs.checkinPoolEmpPanel) {
        this.$refs.checkinPoolEmpPanel.fetchCheckinPool(true)
      }
    },
    newAccountRegistered() {
      this.showRegisterDialog = false
      this.$toast.success("Neuer Account erfolgreich erstellt.")
    },
    showGFRecommendations(userId) {
      if (this.userService.hasRight("ab_create")) {
        this.$router.push("/gfrecommendations/" + userId)
      }
    },
    createAccount() {
      this.showRegisterDialog = true
    },
    createTP(customerId) {
      const targetCustomerId = customerId || (this.selectedCustomer ? this.selectedCustomer._id : null)
      if (targetCustomerId) {
        this.$router.push(`/workouts/create?userId=${targetCustomerId}`)
      } else {
        this.$router.push("/workouts/create")
      }
    },
    createAnamnese(customerId) {
      const targetCustomerId = customerId || (this.selectedCustomer ? this.selectedCustomer._id : null)
      this.$refs.anamneseBogenRef.setVisible(null, false, false, targetCustomerId)
    },
    createInteraction(customerId) {
      const targetCustomerId = customerId || (this.selectedCustomer ? this.selectedCustomer._id : null)
      this.$refs.customerInteraction.setVisible(targetCustomerId)
    },
  },
}
</script>

<style scoped>
/* Bestehende Styles */
.panel-header {
  display: flex;
  align-items: center;
  background-color: #212121;
  color: white;
  padding: 10px 16px;
  font-weight: bold;
  border-bottom: 7px solid var(--v-primary);
}
.header-title {
  font-size: 1.2rem;
  flex-grow: 1;
  text-align: center;
  margin-left: -64px;
  padding-left: 64px;
}
.employee-chip {
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.1);
  padding: 4px 12px;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 0.9rem;
  font-weight: 500;
  margin-right: 12px;
  flex-shrink: 0;
}
.employee-chip:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

/* Styles für die Aktions-Karten */
.glass-action-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  min-height: 170px;
  padding: 24px;
  border-radius: 20px !important;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  overflow: hidden;
  background: rgba(255, 255, 255, 0.65) !important;
  border: 1px solid rgba(224, 224, 224, 0.85) !important;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.08) !important;
}

.glass-action-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.12) !important;
  border-color: rgba(var(--v-primary-base), 0.5) !important;
}

.card-icon {
  color: var(--v-primary-base) !important;
  opacity: 0.9;
}

.card-title {
  font-weight: 700;
  font-size: 1.3rem;
  color: #1e1e1e;
}

.card-subtitle {
  font-size: 0.9rem;
  color: #555;
  margin-top: 4px;
}

/* NEUE Styles für den "Kunde suchen" Dialog */
.glass-dialog-card {
  background: rgba(255, 255, 255, 0.8) !important;
  border-radius: 20px !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.15) !important;
  padding-top: 16px;
}

.glass-dialog-card .v-card__title {
  color: #1e1e1e;
}
</style>
